import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { RegnExamDataComponent } from '../regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';
import { DatePipe } from '@angular/common';
import { StudentDetailsComponent } from '../student-details/student-details.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-scrutiny-report',
  templateUrl: './scrutiny-report.component.html',
  styleUrls: ['./scrutiny-report.component.scss']
})
export class ScrutinyReportComponent implements OnInit { 
  SearchRegnForm: FormGroup;
  APIService: string;
  courseList: any;
  filteredcourseList: any;
  SessionFilterList: any;
  sessionList: any;
  filteredCollegeList: any;
  collegeList: any;
  dialogRef: MatDialogRef<any>;
  filteredSrtyList: any;
  SrtyList: any;
  GridData: any;
  Table = false;
  selectedRow: any | null = null;
  isFinalApproval: boolean = false;
  LoginId: number = 0;
  userPermission: any;
  utp: string;
  sessionData: any;
  pendingCount: number = 0;
  docErrorCount: number = 0;
  resubmitCount: number = 0;
  apprCount: number = 0;
  statusData: any;

  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    public datepipe: DatePipe,    private location: Location,
    private dialog: MatDialog,public router: Router
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    this.sessionData = JSON.parse(sessionStorage.getItem("sessionId"));
    this.SearchRegnForm = this.fb.group({
      Status: new FormControl(''),
      SnNo: new FormControl(''),
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
    })
    
    this.fetchCount();
    this.getCourseData();
    this.fetchSession();
    this.getCollegeData(null);
    this.fetchSrty();
  }

  cards = [
    { label: 'Approved', key: 'appr', count: () => this.apprCount },
    { label: 'Pending', key: 'pend', count: () => this.pendingCount },
    { label: 'Document error', key: 'docErr', count: () => this.docErrorCount },
    { label: 'Resubmitted', key: 'resub', count: () => this.resubmitCount }
  ]

  fetchCount() {
    let payload = {};
    payload['CgCode'] = this.SearchRegnForm.value?.CgCode ? this.SearchRegnForm.value.CgCode : '';
    payload['CoCode'] = this.SearchRegnForm.value?.CoCode ? this.SearchRegnForm.value.CoCode : '';
    payload['LoginId'] = sessionStorage.getItem('userId');;
    payload['SessionId'] = this.sessionData;
    this.umsService.getCount(payload).subscribe(res => {
      if(res?.data[0]) {
        this.pendingCount = res.data[0].PENDCount;
        this.docErrorCount = res.data[0].DCERRCount;
        this.resubmitCount = res.data[0].RESUBCount;
        this.apprCount = res.data[0].APPRCount;
      }
    })
  }

  sessionSelection(SnNo: any) {
    this.sessionData = SnNo;
    this.fetchCount();
  }

  isFinalApprovedRow(item: any): boolean {
    if (!item) return false;
    return item.FinalApproval === 1 && Number(item.UserId) === this.LoginId;
  }
  fetchSrty() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SRTY';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.SrtyList = (res.data).filter(x => x.CdCode != 'BCKP');
        this.filteredSrtyList = this.SrtyList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      // let data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Alert';
      // data['icon'] = 'fas fa-close';
      // this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  getCourseData() {
    this.spinner.show();
    const payload = {};
    if(this.userPermission[0].CgUi === 'C') {
      payload['LoginId'] = sessionStorage.getItem('userId');
    }
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredcourseList = this.courseList.slice();
      // this.getCollegeData();
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseList = [];
      // let data = {}
      // data['message'] = ERROR.error.message
      // data['title'] = 'Information'
      // data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = ''; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

  getCollegeData(CoCode) {
    this.spinner.show();
    this.fetchCount();
    const payload = {};
    if(this.userPermission[0].CgUi === 'C') {
      payload['LoginId'] = sessionStorage.getItem('userId');
      payload['CoCode'] = null;
    }
    else {
      payload['CoCode'] = CoCode;
      payload['LoginId'] = null;
    }
    this.umsService.courseClg(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
      if (res.data.length === 1) {
      this.SearchRegnForm.patchValue({
        CgCode: res.data[0].CgCode
      });
    }
    
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }
  Back(){
    this.goBack();
   }
   goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  reset(){
    this.SearchRegnForm.reset();
    this.fetchCount();
    this.Table = false
  }

  getData(data){
    this.GridData = []
    this.Table = false;
    this.spinner.show();
    this.statusData = data.toUpperCase();
     if(data === 'docErr') {
      this.statusData = 'DCERR'
    }
    let payload;
    this.LoginId = Number(sessionStorage.getItem('LoginId')) || Number(sessionStorage.getItem('userId')) || 0;
    const loggedInUserId = parseInt(sessionStorage.getItem('userId') || '0');
    const statusMap = {
      pend: 'PEND',
      docErr: 'DCERR',
      appr: 'APPR',
      resub: 'RESUB'
    };

    payload = {
      CgCode: data === 'list' || this.SearchRegnForm.value.CgCode ? this.SearchRegnForm.value.CgCode : '',
      CoCode: data === 'list' || this.SearchRegnForm.value.CoCode ? this.SearchRegnForm.value.CoCode : '',
      SessionId: data === 'list' ? this.SearchRegnForm.value.SnNo : this.sessionData,
      Status: data === 'list' ? this.SearchRegnForm.value.Status : statusMap[data],
      LoginId: this.LoginId
    };
    this.umsService.SearchScrutinyReport(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide();
          if (res.status && res.data?.length) {
        this.GridData = res.data.map((row: any) => {
          let scrutinyBy = '';
          if (row.ApprovalStatus === 'Pending') {
            scrutinyBy = row.PendingByUserName ?? '';   
          } 
          else if (row.Status === 'APPR') {
            scrutinyBy = row.ApprovedByUserName ?? '';
          } 
          else if (row.Status === 'DCERR') {
            scrutinyBy = row.DocErrByUserName ?? 'Document Error';
          }
          else if (row.Status === 'REJT') {
            scrutinyBy = row.RejectedByUserName ?? '';
          }
          else if(row.Status == 'ReSubmitted') {
            scrutinyBy = row.ResubmittedByUserName ?? '';
          }
          return {
            ...row,
              ScrutinyBy: scrutinyBy, 
            isApproved: row.ApprovalStatus === 'Approved',
            isPending: row.ApprovalStatus === 'Pending',
            UserId: Number(row.UserId),
            FinalApproval: Number(row.FinalApproval)
          };
        });
        this.isFinalApproval = true;
        this.Table = true;
        }
      }
        else{
          this.spinner.hide();
          this.Table = false;
          this.GridData = []
        }
      
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.Table = false;
        this.GridData = []
      })
  }


  getstuid(){
    this.selectedRow;   
    // let payload = {}
    // payload['StuRgNo']= this.selectedRow.StuRgNo;
    // payload['StudentId']= '';
    // this.umsService.getStuId(payload).subscribe((res) => {
    //   this.spinner.hide();
      // this.router.navigate(['student-profile'],
      // { queryParams: { 
      //   StudentId: res.data[0].StuId,
      //   from:'report',
      //   SessionId:this.selectedRow.SessionId
      // }}
      // ); 
      const studentId = this.selectedRow.StudentId;
      const sessionId = this.selectedRow.SessionId;

      this.router.navigate(['student-profile'], {
        state: {
          StudentId:studentId,
          from: 'report',
          SessionId:sessionId
        }
      });
    }
  //   ,(ERROR: HttpErrorResponse) => {
  //     this.spinner.hide();
  //   })
    
  // }


  selected(data){
    this.selectedRow = data;
  }

   // 504
  //  download(){
  //   var filter: any;
  //   const payload1 = this.SearchRegnForm.value.Status;
  //   let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
  //   var filter: any; 
  //   filter = {
  //     "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
  //     "RptCode": 504,
  //     "InstName": '',
  //     "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
  //     "ShId": '',
  //     "CgCode": this.SearchRegnForm.value.CgCode,
  //     "RollNo": '',
  //     "Cent": '',
  //     "TnCode": '',
  //     "EsId": '',//this.emid
  //     "CsNo": '',
  //     "PgBreak": '',
  //     "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
  //     "StrCode": '',
  //     "RgNo": '',
  //     "UC": '',
  //     "Ledger": '',
  //     "RegnRoll": '',
  //     "DsCode": '',
  //     "CoCode": this.SearchRegnForm.value.CoCode,
  //     "SnNo": this.SearchRegnForm.value.SnNo,
  //     "Extra1": JSON.stringify(payload1),
  //   }
  //   var payload: any;
  //   payload = filter;
  //   this.umsService.setData(JSON.stringify(payload));
  //   this.redirect('reports')
  // }
  download1(event: Event) {
  event.preventDefault();
  if(this.statusData && this.statusData != 'LIST') {
    this.SearchRegnForm.patchValue({
      Status : this.statusData
    })
  }
  const payload: any = {
    LoginId: parseInt(sessionStorage.getItem('userId')) || 0,
    CgCode: this.SearchRegnForm.value.CgCode,
    CoCode: this.SearchRegnForm.value.CoCode,
    SessionId: this.SearchRegnForm.value.SnNo ? this.SearchRegnForm.value.SnNo : this.sessionData,
    Status: this.SearchRegnForm.value.Status,
  };

  this.umsService.SearchScrutinyReport(payload).subscribe((res) => {
    if (res.status && res.data?.length) {
      const filteredData = res.data.filter((element: any) => element.FinalApproval === 1);
      const extractedData = res.data.map((element: any, index: number) => {
       const isPendingSelected = (this.SearchRegnForm.value.Status ? this.SearchRegnForm.value.Status : this.statusData) === 'PEND';
       let displayStatus = '';
        if (isPendingSelected) {
          displayStatus = 'Pending';
        } else {
          displayStatus = element.Status;
          if (element.Status === 'APPR') displayStatus = 'Approve';
          if (element.Status === 'DCERR') displayStatus = 'Document Error';
          if (element.Status === 'REJT') displayStatus = 'Reject';
          if (element.Status === 'Submitted' || element.Status === 'ReSubmitted') {
            displayStatus = 'Resubmitted';
          }
        }
        let scrutinyBy = '';

if (element.ApprovalStatus  === 'Pending') {
  scrutinyBy = element.PendingByUserName ?? 'Pending';
} else if (element.Status === 'APPR') {
  scrutinyBy = element.ApprovedByUserName ?? '';
} else if (element.Status === 'DCERR') {
  scrutinyBy = element.DocErrByUserName ?? '';
} else if (element.Status === 'ReSubmitted') {
  scrutinyBy = element.ResubmittedByUserName ?? '';
} else if (element.Status === 'REJT') {
  scrutinyBy = element.RejectedByUserName ?? '';
} 
        return {
            SrNo: index + 1,
            CertificateSLNo: element.stuPerId || "",
            RegistrationNo: element.stuPerRgNo || "",
            StudentName: element.StuFullNameEng || "",
            MobileNumber: element.StuNumber || "",
            AadhaarNo: element.StuAadhaarNo || "",
            Gender: element.StuGender === 'M' ? 'Male' : 'Female',   
            DOB: element.StuBirthDate ? new Date(element.StuBirthDate).toLocaleDateString('en-GB') : "",
            CollegeName: element.CgName || "",
            CourseName: element.CoName || "",
            Comment: element.Comment || "",
            Status: displayStatus || "",
            ScrutinyBy : scrutinyBy || ""
          };
        });
      const csvContent = this.convertArrayToCSV(extractedData);
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      if(res.data[0].Status === 'DCERR') {
        link.download = 'DocumentError_Scrutiny_Report.csv';
      }
      else if(res.data[0].Status === "Resubmitted") {
        link.download = 'Resubmitted_Scrutiny_Report.csv';
      }
      else if(res.data[0].Status === "Submitted") {
        link.download = 'Pending_Scrutiny_Report.csv';
      }
      else {
        link.download = 'Approved_Scrutiny_Report.csv';
      }
      // link.download = 'ScrutinyReport.csv';
      document.body.appendChild(link);
      // link.download = `${status}Scrutiny_Report.csv`;
      document.body.appendChild(link);
      link.click();
    } else {
      console.warn('No data found for download.');
    }
  });
}
convertArrayToCSV(array) {
    const header = Object.keys(array[0]).join(',');
    const rows = array.map(obj => Object.values(obj).map(value => `"${value}"`).join(','));
    return [header, ...rows].join('\n');
  }

  
  redirect(to): void {
    this.router.navigate([to]);
  }
}
